module.exports = __webpack_public_path__ + "img/accentpay.0b0779fb.svg";